import { z } from 'zod';
export const SUPPORTED_TIMEZONES = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
    'Australia/Sydney',
    'Europe/London',
];
export const WEEKDAYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];
const WEEKDAY_SCHEDULE = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
const HH_MM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;
const DayScheduleSchema = z
    .object({
    day: z.enum(WEEKDAYS),
    start: z.string().regex(HH_MM_REGEX, 'Must be HH:mm format (24h)'),
    end: z.string().regex(HH_MM_REGEX, 'Must be HH:mm format (24h)'),
})
    .refine((s) => s.start < s.end, {
    message: 'start must be before end',
});
export const WorkingHoursSchema = z.object({
    timezone: z.enum(SUPPORTED_TIMEZONES),
    schedule: z.array(DayScheduleSchema),
});
function weekdaySchedule(start, end) {
    return WEEKDAY_SCHEDULE.map((day) => ({ day, start, end }));
}
export const WORKING_HOURS_PRESETS = [
    {
        key: 'morning',
        label: 'Morning Shift',
        description: '10:00 AM – 6:00 PM AEST (Sydney)',
        value: { timezone: 'Australia/Sydney', schedule: weekdaySchedule('10:00', '18:00') },
    },
    {
        key: 'mid',
        label: 'Mid Shift',
        description: '8:00 AM – 5:00 PM GMT (UK)',
        value: { timezone: 'Europe/London', schedule: weekdaySchedule('08:00', '17:00') },
    },
    {
        key: 'night',
        label: 'Night Shift',
        description: '8:00 AM – 4:00 PM PST (LA)',
        value: { timezone: 'America/Los_Angeles', schedule: weekdaySchedule('08:00', '16:00') },
    },
];
//# sourceMappingURL=working-hours.js.map